import { render } from "./InvoiceModal.vue?vue&type=template&id=224de010&ts=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=ts"
export * from "./InvoiceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__